import { useNavigate } from 'react-router'
import { Text } from '../text/Text.tsx'
import { Button } from '../button/Button.tsx'
import { StatusPage } from './StatusPage.tsx'
import styles from './StatusPage.module.css'

export interface NotFoundProps {
  message?: string
  homePath?: string
  onGoBack?: () => void
}

export function NotFound({ message, homePath = '/', onGoBack }: NotFoundProps) {
  const navigate = useNavigate()

  return (
    <StatusPage>
      <div className={styles.glitch} data-text="404">404</div>
      <Text as="h1" size="xl" weight="bold" className={styles.title}>
        You&apos;ve been eliminated
      </Text>
      <Text as="p" size="sm" muted className={styles.subtitle}>
        {message ?? "This page doesn't exist. Maybe it was banned for smurfing."}
      </Text>
      <div className={styles.actions}>
        <Button variant="primary" size="sm" onClick={() => navigate(homePath)}>
          Respawn at Home
        </Button>
        <Button variant="ghost" size="sm" onClick={onGoBack ?? (() => navigate(-1))}>
          Go Back
        </Button>
      </div>
      <Text as="p" size="xs" muted className={styles.hint}>
        Respawning in... just kidding, click a button.
      </Text>
    </StatusPage>
  )
}
